var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondForwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10L18.7227 10.416C18.9524 10.5692 19.2628 10.5071 19.416 10.2774L19 10ZM16.2774 7.58397C16.0476 7.4308 15.7372 7.49289 15.584 7.72265C15.4308 7.95241 15.4929 8.26285 15.7226 8.41603L16.2774 7.58397ZM21.416 7.27735C21.5692 7.04759 21.5071 6.73715 21.2773 6.58397C21.0476 6.4308 20.7372 6.49289 20.584 6.72265L21.416 7.27735ZM18.4472 14.2236C18.5707 13.9766 18.4706 13.6763 18.2236 13.5528C17.9766 13.4293 17.6763 13.5294 17.5528 13.7764L18.4472 14.2236ZM10 18.5C5.30558 18.5 1.5 14.6944 1.5 10H0.5C0.5 15.2467 4.75329 19.5 10 19.5V18.5ZM1.5 10C1.5 5.30558 5.30558 1.5 10 1.5V0.5C4.75329 0.5 0.5 4.75329 0.5 10H1.5ZM10 1.5C14.6944 1.5 18.5 5.30558 18.5 10H19.5C19.5 4.75329 15.2467 0.5 10 0.5V1.5ZM19.2773 9.58397L16.2774 7.58397L15.7226 8.41603L18.7227 10.416L19.2773 9.58397ZM19.416 10.2774L21.416 7.27735L20.584 6.72265L18.584 9.72265L19.416 10.2774ZM10 19.5C12.0875 19.5 13.8114 18.9767 15.2149 18.041C16.6152 17.1074 17.6676 15.7829 18.4472 14.2236L17.5528 13.7764C16.8324 15.2171 15.8848 16.3926 14.6601 17.209C13.4386 18.0233 11.9125 18.5 10 18.5V19.5Z",
    fill: "rgba(0, 0, 0, 0.45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0955 6.72727V14H9.99467V7.82812H9.95206L8.212 8.96449V7.91335L10.0266 6.72727H11.0955Z",
    fill: "rgba(0, 0, 0, 0.45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondForwardIcon);
export default __webpack_public_path__ + "static/media/secondForwardIcon.8c8f438cecbe78678d2753cbd03078f4.svg";
export { ForwardRef as ReactComponent };